import { IAmbulance } from './ambulance'
import { IBase } from './base'
import { IEmployee } from './employee'

export interface IWorkplaceTemplate extends IBase {
	name: string
}
export interface IWorkplaceReduced extends IBase {
	name: string
	code: string
	level: string
	templates: IWorkplaceTemplate[]
	realStatus: string
	externalId: string
}

export interface IWorkplace extends IWorkplaceReduced {}

export interface IOrderWorkplace {
	id: number
	name: string
	ambulance: IAmbulance
	employee: IEmployee | null
	hasOrderableTemplates: boolean
}

export interface ITemplate {
	id: number
	name: string
	price: number | null
	timeslots: ITemplateTimeslot[]
	workplace: IOrderWorkplace
	msgImportant: string
	description: string
	employee?: IEmployee | null
	/** Voliteľné pri odpovedi z e-commerce produktov — rovnaký tvar ako pri detaile termínu. */
	insuranceCompanies?: {
		insuranceCompany: IOrderInsuranceCompany
		price: number
		description: string | null
	}[]
}

export interface ITemplateTimeslot {
	id: number
	startTime: string
	endTime: string
	free: boolean
	template: ITemplate
}

export interface IOrderTimeSlotDetail {
	id: number
	startTime: string
	endTime: string
	template: IOrderTemplateDetail
	free: boolean
}

export interface IOrderTemplateDetail {
	id: number
	name: string
	description: any
	price: number
	msgImportant: any
	workplace: IOrderWorkplace
	insuranceCompanies: {
		insuranceCompany: IOrderInsuranceCompany
		price: number
		description: string | null
	}[]
	employee: IEmployee | null
}

export enum INSURANCE_COMPANY_CODE_ENUM {
	SELF_PAID = 'SA00',
	DOVERA_EU = '24EU',
	DOVERA = '2400',
	VSZP_MU = '25MU',
	VSZP_EU = '25EU',
	VSZP = '2500',
	UNION_KP = '77',
	UNION_EU = '27EU',
	UNION = '2700'
}

export interface IOrderInsuranceCompany {
	id: number
	name: string
	code: INSURANCE_COMPANY_CODE_ENUM
}
